import { ENDPOINTS } from "Config/endpoints";
import protectedApi from "Config/protectedApi";

export const getD_leadFn = (req) => {
    const response = protectedApi.get(`${ENDPOINTS.Direct_lead}`, { params: req });
    return response;
}


export const postD_leadFn = (reqBody) => {
    const response = protectedApi.post(`${ENDPOINTS.Direct_lead}`, reqBody);
    return response;
}

export const patchD_leadFn = (reqBody) => {
    const response = protectedApi.patch(`${ENDPOINTS.Direct_lead}`, reqBody);
    return response;
}

export const deleteD_leadFn = (reqBody) => {
    const response = protectedApi.delete(`${ENDPOINTS.Direct_lead}`, { data: reqBody });
    return response;
}

export const getCategoryFn = (req) => {
    const response = protectedApi.get(`${ENDPOINTS.category_Api}`, { params: req });
    return response;
}




export const getSeller_leadFn = (req) => {
    const response = protectedApi.get(`${ENDPOINTS.admin_lead}`, { params: req });
    return response;
}

export const postSeller_leadFn = (reqBody) => {
    const response = protectedApi.post(`${ENDPOINTS.admin_lead}`, reqBody);
    return response;
}

export const patchSeller_leadFn = (reqBody) => {
    const response = protectedApi.patch(`${ENDPOINTS.admin_lead}`, reqBody);
    return response;
}

export const deleteSeller_leadFn = (reqBody) => {
    const response = protectedApi.delete(`${ENDPOINTS.admin_lead}`, { data: reqBody });
    return response;
}



export const getSellersForleadFn = (req) => {
    try {
        const response = protectedApi.get(`${ENDPOINTS.seller_list}`, { params: req });
        return response;
    } catch (error) {
        throw error;
    }
}




export const getSellersForleadwithIdFn = (req) => {
    try {
        const response = protectedApi.get(`${ENDPOINTS.seller_list_forlead}`, { params: req });
        return response;
    } catch (error) {
        throw error;
    }
}
